import script from "./SplineX.vue?vue&type=script&lang=js"
export * from "./SplineX.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__